import { useDrivers } from '@/modules/shared/context/drivers/DriversContext'
import * as React from 'react'
import DriversContractTable from '../components/tables/ContractsGeneral/DriversContractTable'
import ContractActionBar from '@/modules/drivers/shared/actionBars/ContractActionBar'
import { useSideSelectionStore } from '@/modules/drivers/stores/sideSelectionStore'
const ContractGroup = ({ companyId }: { companyId: string }) => {
  const { basicDrivers } = useDrivers()
  const { sideCheckedIds } = useSideSelectionStore()

  const displayedDrivers =
    sideCheckedIds.length > 0
      ? basicDrivers.filter((d) => sideCheckedIds.includes(d.id))
      : []
  return (
    <>
      <div className="tw-relative tw-bg-content-primary">
        <ContractActionBar
          companyId={companyId}
          driverIds={displayedDrivers.map((driver) => driver.id)}
        />
      </div>
      <div className="tw-z-10 tw-flex tw-flex-1 tw-flex-col tw-overflow-hidden">
        <DriversContractTable drivers={displayedDrivers} companyId={companyId} />
      </div>
    </>
  )
}

export default ContractGroup
